



























import { Vue, Component } from "vue-property-decorator";
import ItemData from "../model/ItemData";
@Component
export default class inputbox extends Vue {
  cateflag: boolean = false;
  item: ItemData = new ItemData(-1, 0);
  constructor() {
    super();
  }
  selectCate(id: number): void {
    this.cateflag = false;
    this.item.categoryId = id;
  }
  created(): void {
    this.item = this.$store.state.transItem;
  }

  submit(): void {
    if (
      this.item &&
      this.item.title.trim().length > 0 &&
      this.item.content.trim().length > 0
    ) {
      if (this.item.id > -1) {
        this.$store.state.actionHelper.editData(this.item);
      } else {
        this.$store.state.actionHelper.addData(this.item);
      }
      this.close();
    } else {
      window.alert("内容不能为空!!!");
    }
  }
  close() {
    this.$store.commit("showInput");
  }
}
